$(function(){

	let emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let phonePattern = /^(\+|[0-9])(([ \-]|[\-])?)?((\(\d{3}\))|(\d{3}))?([ \-])?(\d{3}[\- ]?\d{2}[\- ]?\d{2,6})$/;
    let phoneCodePattern = /^\+[1-9][0-9]{0,3}$/;

    let namePhoneCode = 'DATA[PHONE_CODE]';
    let namePhoneNum = 'DATA[PHONE_NUM]';
    let namePhone = 'DATA[PHONE]';
    let nameEmail = 'DATA[EMAIL]';
    let nameAgree = 'DATA[AGREE]';

	$("[data-check]").on('change keyup', function() {
		ValidateFields($(this));
	});

	$('form').on('submit', function(event) {
		event.stopImmediatePropagation();
		var $this = $(this),
			$form = $this,
			$fields = $form.find("[data-check]"),
			validation = ValidateFields($fields);
		if(validation !== true){
			event.preventDefault();
		} else {
			$form.trigger('submit_success');
			event.returnValue = true;
		}
	});

	function ValidateFields(fields) {
		var errors = 0;

		$.each($(fields), function(index, val) {
			var $this = $(val),
				value = $this.val(),
				name = $this.attr('name'),
				ok = false;

            if (typeof value === 'string') {
                value = value.trim();

                if (name === namePhoneCode) {
                    value = '+' + value.replace(/^0+|\D/gi, '');
                    $this.val(value);
                }
            }

			if ((name === namePhoneCode && phoneCodePattern.test(value)) ||
			    (name === namePhoneNum && phonePattern.test(value)) ||
                (name === namePhone && phonePattern.test(value)) ||
                (name === nameEmail && emailPattern.test(value))
            ) {
				ok = true;
			}

			if (name !== namePhoneCode &&
                name !== namePhoneNum &&
                name !== namePhone &&
                name !== nameEmail &&
                name !== nameAgree
            ) {
				if (value.length >= 3) {
					ok = true;
				}
			}

			if (name === nameAgree) {
				if ($this.next('.checkmark').length != null) {
					if ($this.prop('checked')) {
						ok = true;
						$this.next('.checkmark').removeClass("error").addClass('ok');
					} else {
						$this.next('.checkmark').removeClass("ok").addClass('error');
					}
				} else {
					if ($this.prop('checked')) {
						ok = true;
					}
				}
			}

			if (ok) {
				$this.removeClass("error").addClass('ok');
			} else {
				errors++;
				$this.removeClass("ok").addClass('error');
			}
		});

		if (errors) {
			return false;
		} else {
			return true;
		}
	}

});
